import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const intro = r => require.ensure([], () => r(require('@/pages/intro')), 'intro')
const login = r => require.ensure([], () => r(require('@/pages/login')), 'login')
const manage = r => require.ensure([], () => r(require('@/pages/manage')), 'manage')
const productForSaleManage = r => require.ensure([], () => r(require('@/pages/productForSaleManage')), 'productForSaleManage')
const productManage = r => require.ensure([], () => r(require('@/pages/productManage')), 'productManage')
const productInfoManage = r => require.ensure([], () => r(require('@/pages/productInfoManage')), 'productInfoManage')
const productSetManage = r => require.ensure([], () => r(require('@/pages/productSetManage')), 'productSetManage')
const openAreaManage = r => require.ensure([], () => r(require('@/pages/openAreaManage')), 'openAreaManage')
const appointmentManage = r => require.ensure([], () => r(require('@/pages/appointmentManage')), 'appointmentManage')
const orderManage = r => require.ensure([], () => r(require('@/pages/orderManage')), 'orderManage')
const userManage = r => require.ensure([], () => r(require('@/pages/userManage')), 'userManage')
const vipCardManage = r => require.ensure([], () => r(require('@/pages/vipCardManage')), 'vipCardManage')
const shopInfo = r => require.ensure([], () => r(require('@/pages/shopInfo')), 'shopInfo')

const statisticOrderDetail = r => require.ensure([], () => r(require('@/pages/statisticOrderDetail')), 'statisticOrderDetail')
const printOrder = r => require.ensure([], () => r(require('@/pages/printOrder')), 'printOrder')

const router = new Router({
  strict: process.env.NODE_ENV !== 'production',
  routes: [{
    path: '/intro',
    name: 'intro',
    component: intro,
    meta: {
      title: '告白星厨'
    }
  }, {
    path: '/',
    name: 'login',
    component: login
  }, {
    path: '/manage',
    name: 'manage',
    component: manage,
    children: [{
        path: '/manage/productForSaleManage',
        name: 'productForSaleManage',
        component: productForSaleManage
      },
      {
        path: '/manage/productManage',
        name: 'productManage',
        component: productManage
      },
      {
        path: '/manage/productInfoManage',
        name: 'productInfoManage',
        component: productInfoManage
      },
      {
        path: '/manage/productSetManage',
        name: 'productSetManage',
        component: productSetManage
      },
      {
        path: '/manage/openAreaManage',
        name: 'openAreaManage',
        component: openAreaManage
      },
      {
        path: '/manage/appointmentManage',
        name: 'appointmentManage',
        component: appointmentManage
      },
      {
        path: '/manage/userManage',
        name: 'userManage',
        component: userManage
      },
      {
        path: '/manage/orderManage',
        name: 'orderManage',
        component: orderManage
      },
      {
        path: '/manage/vipCardManage',
        name: 'vipCardManage',
        component: vipCardManage
      },
      {
        path: '/manage/statisticOrderDetail',
        name: 'statisticOrderDetail',
        component: statisticOrderDetail
      },
      {
        path: '/manage/printOrder',
        name: 'printOrder',
        component: printOrder
      },
      {
        path: '/manage/shopInfo',
        name: 'shopInfo',
        component: shopInfo
      }
    ]
  }]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js